import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { lg } from "../BreakPoints";
import trelloLogo from "../Images/Yentra-logo.png";

const Container = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: transparent;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  z-index: 100;

  ${lg({
    justifyContent: "space-between",
  })}
`;

const Icon = styled.img`
  margin-left: 1rem;
  ${lg({
    marginLeft: "0",
  })}
`;

const RightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const Link = styled.a`
  text-decoration: none;
  cursor: pointer;
  color:  #056dc2;
  font-weight: 500;
  font-size: 1.1rem;
  &:hover {
    color:  #056dc2;
    text-decoration: none;
    scale: 1.05;
  }
`;

const Button = styled.button`
  background-color: #056dc2;
  border-radius: 0.4rem;
  padding: 0.5rem 1rem;
  color: white;
  border: none;
  cursor: pointer;
  &:hover {
    background-color: rgb(24, 115, 194);
  }
`;

const IndexNav = () => {
  let history = useHistory();
  return (
    <Container>
      <Icon src={trelloLogo} style={{ height: "150px" }} />
      <RightSide>
        <Link onClick={() => history.push("/login")}>Log in</Link>
        <Button onClick={() => history.push("/register")}>Sign up</Button>
      </RightSide>
    </Container>
  );
};

export default IndexNav;
